import { AICodingJobDetailsDto } from "app/V2ApiClient";
import { VariableItemVM } from "./aiCodingState";

export const mapJobDetailsToVariableVM = (dto: AICodingJobDetailsDto): VariableItemVM | undefined => {
  if (!dto?.variables) return undefined;

  const variableNames = dto.variables.map((v) => v.variableName ?? "");
  const variableReportingNames = dto.variables.map((v) => v.variableReportingName ?? "");
  
  return {
    variableNames: variableReportingNames,
    question: dto.variables[0].questionLabel ?? "",
    stats: {},

    jobInfo: {
      variables: variableNames,
      codingType: dto.variables[0].params?.codingType ?? "",
      answerType: dto.variables[0].params?.isMultiCode ? "Multiple" : "Single",
      translation: dto.variables[0].params?.isTranslate ? (dto.variables[0].params?.translationEngine ?? "") : "",
      filter: dto.variables[0].params?.filters,
    },

    isExpanded: false,
  };
};
